import { makeStyles } from "@fluentui/react-components";
import { Help } from "components/help/help";
import designTokens from "theme/customTheme";

const useStyles = makeStyles({
  pageContainer: {
    backgroundColor: designTokens.neutral[50],
    width: "100%",
    maxWidth: "100vw",
    overflowX: "hidden",
    boxSizing: "border-box",
  },
});

export const HelpPage = (): JSX.Element => {
  const styles = useStyles();

  return (
    <div className={styles.pageContainer}>
      <Help />
    </div>
  );
};
